<template>
    <div class="ui-select-facebook-integration">
        <ui-overlay-load v-if="load" />

        <div v-if="optionsComputed.length > 0" class="items-wrapper">
            <div class="items-scroller" v-scroll-paginate="changePage">
                <div class="items">
                    <div v-for="option of value"
                        :key="option.id"
                        :class="{ 'current': option == selected }"
                        class="item"
                        @click="select(option)">
                        <ui-facebook-integration-card :data="option" />
                        <i class="fal fa-check"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="ui-no-content" v-else>
            <div class="title">Nenhuma conta do Facebook encontrada.</div>
        </div>
    </div>
</template>

<script>
    import { uiOverlayLoad } from '@/components/ui'
    import uiFacebookIntegrationCard from "../facebook-integration-card"
    import { scrollPaginate } from '@/directives'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            uiFacebookIntegrationCard,
            uiOverlayLoad,
        },

        props: {
            value: {
                type: Array,
                required: false,
                default () {
                    return []
                }
            },
            default: {
                type: Number,
                required: false,
            },
            load: {
                type: Boolean,
                required: false,
            }
        },

        directives: {
			scrollPaginate,
		},

        data() {
            return {
                selected: null,
            }
        },

        created: async function () {
            await this.$nextTick(() => {
                if (this.default && this.optionsComputed) {
                    this.selected = this.optionsComputed.find(option => option.id === this.default)
                    this.$emit("input", this.selected)
                }
            })
        },

        computed: {
            ...mapGetters('facebook', {
                getStatusAside: 'getStatusAside',
            }),
            optionsComputed() {
                return this.value
            },
            selectedComputed: {
                get() {
                    return this.default ? this.optionsComputed[this.default] : this.selected
                },
                set(value) {
                    this.selected = value
                    if (value) this.$emit('input', value)
                }
            },
        },

        methods: {
            select(option) {
                this.$store.dispatch('facebook/setStatusAside', true)
                if (this.selectedComputed !== option) {
                    this.selectedComputed = option
                    this.subscribePageWebhook()
                }
            },
            subscribePageWebhook() {
                let pageId = this.selectedComputed.id
                let pageToken = this.selectedComputed.access_token
                /** A variável FB não foi declarada por vir do script de SDK do Facebook */
                // eslint-disable-next-line no-undef
                FB.api('/' + pageId + '/subscribed_apps?access_token=' + pageToken, 'post', {
                    subscribed_fields: 'leadgen'
                })
            },

            changePage() {
                this.$emit('loadPages', null)
            }
        },

        watch: {
            value(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.selected = null
                    this.selectedComputed = null
                }
            },
            getStatusAside(newValue) {
                if (!newValue) this.selectedComputed = null
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>